/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Negotiate_Mistake_5Inputs */

const en_salary_negotiate_mistake_5 = /** @type {(inputs: Salary_Negotiate_Mistake_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Making ultimatums or being confrontational`)
};

const de_salary_negotiate_mistake_5 = /** @type {(inputs: Salary_Negotiate_Mistake_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultimaten stellen oder konfrontativ auftreten`)
};

const fr_salary_negotiate_mistake_5 = /** @type {(inputs: Salary_Negotiate_Mistake_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poser des ultimatums ou être confrontant`)
};

const es_salary_negotiate_mistake_5 = /** @type {(inputs: Salary_Negotiate_Mistake_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hacer ultimátums o ser confrontativo`)
};

const it_salary_negotiate_mistake_5 = /** @type {(inputs: Salary_Negotiate_Mistake_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dare ultimatum o essere conflittuali`)
};

const nl_salary_negotiate_mistake_5 = /** @type {(inputs: Salary_Negotiate_Mistake_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultimatums stellen of confronterend zijn`)
};

const pl_salary_negotiate_mistake_5 = /** @type {(inputs: Salary_Negotiate_Mistake_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stawianie ultimatum lub bycie konfrontacyjnym`)
};

const fi_salary_negotiate_mistake_5 = /** @type {(inputs: Salary_Negotiate_Mistake_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uhkavaatimusten esittäminen tai vihamielisyys`)
};

const da_salary_negotiate_mistake_5 = /** @type {(inputs: Salary_Negotiate_Mistake_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At stille ultimatummer eller være konfronterende`)
};

const sv_salary_negotiate_mistake_5 = /** @type {(inputs: Salary_Negotiate_Mistake_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Att ställa ultimatum eller vara konfrontativ`)
};

/**
* | output |
* | --- |
* | "Making ultimatums or being confrontational" |
*
* @param {Salary_Negotiate_Mistake_5Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_negotiate_mistake_5 = /** @type {((inputs?: Salary_Negotiate_Mistake_5Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Negotiate_Mistake_5Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_negotiate_mistake_5(inputs)
	if (locale === "fr") return fr_salary_negotiate_mistake_5(inputs)
	if (locale === "es") return es_salary_negotiate_mistake_5(inputs)
	if (locale === "it") return it_salary_negotiate_mistake_5(inputs)
	if (locale === "nl") return nl_salary_negotiate_mistake_5(inputs)
	if (locale === "pl") return pl_salary_negotiate_mistake_5(inputs)
	if (locale === "fi") return fi_salary_negotiate_mistake_5(inputs)
	if (locale === "da") return da_salary_negotiate_mistake_5(inputs)
	if (locale === "sv") return sv_salary_negotiate_mistake_5(inputs)
	return en_salary_negotiate_mistake_5(inputs)
});